<template>
    <div>
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
                :transition="false"
                :reverse-transition="false"
        >
            <v-tab
                    href="#tab-data"
                    key="tab-data"
            >
                Client Data
            </v-tab>
            <v-tab
                    href="#tab-contacts"
                    key="tab-contacts"
            >
                Contacts
            </v-tab>
            <v-tab
                href="#tab-samples"
                key="tab-samples"
            >
                Samples
            </v-tab>
            <v-tab
                    href="#tab-orders"
                    key="tab-orders"
            >
                Orders
            </v-tab>
            <v-tab
                    href="#tab-direcciones"
                    key="tab-direcciones"

            >
                Direcciones facturación
            </v-tab>
            <v-tab
                    href="#tab-envios"
                    key="tab-envios"
            >
                Direcciones de envio
            </v-tab>

            <v-tabs-items>

                <v-tab-item
                        value="tab-data"
                        key="tab-data"
                        lazy
                        :transition="false"
                        :reverse-transition="false"
                >
                    <v-card flat>
                        <DataComponent v-if="model == 'tab-data'" :id="id"></DataComponent>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                        value="tab-contacts"
                        key="tab-contacts"
                        lazy
                        :transition="false"
                        :reverse-transition="false"
                >
                    <v-card flat>
                        <ContactComponent @reload="reload()" v-if="model == 'tab-contacts'" :id="id"></ContactComponent>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                        value="tab-samples"
                        key="tab-samples"
                        lazy
                        :transition="false"
                        :reverse-transition="false"
                >
                    <v-card flat>
                        <SamplesComponent v-if="model == 'tab-samples'" :id="id"></SamplesComponent>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                        value="tab-orders"
                        key="tab-orders"
                        lazy
                        :transition="false"
                        :reverse-transition="false"
                >
                    <v-card flat>
                        <OrdersComponent v-if="model == 'tab-orders'" :id="id"></OrdersComponent>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                        value="tab-direcciones"
                        key="tab-direcciones"
                        lazy
                        :transition="false"
                        :reverse-transition="false"
                >
                    <v-card flat>
                        <DireccionesComponent v-if="model == 'tab-direcciones'" :id="id"></DireccionesComponent>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                        value="tab-envios"
                        key="tab-envios"
                        lazy
                        :transition="false"
                        :reverse-transition="false"
                >
                    <v-card flat>
                        <DireccionesEnvioComponent v-if="model == 'tab-envios'" :id="id"></DireccionesEnvioComponent>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </div>
</template>

<script>
    import DataComponent from './view/DataComponent';
    import SamplesComponent from './view/SamplesComponent';
    import OrdersComponent from './view/OrdersComponent';
    import ContactComponent from './view/ContactComponent';
    import DireccionesComponent from './view/DireccionesComponent';
    import DireccionesEnvioComponent from './view/DireccionesEnvioComponent'

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-data'
            }
        },
        created () {
            this.setSectionTitle();
        },
        methods: {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Clients detail.'
                });
            }
        },
        components: {
            DataComponent,
            SamplesComponent,
            OrdersComponent,
            ContactComponent,
            DireccionesComponent,
            DireccionesEnvioComponent
        }
    }
</script>

<style scoped>
    .v-tabs .v-window__container {
        height: auto !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/clients/DetailComponent.vue